var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _c("div", { staticClass: "trbo-a-notification__wrapper" }, [
      _c("div", { staticClass: "trbo-a-notification__text" }, [
        _vm._v("\n      " + _vm._s(_vm.message) + "\n    "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "trbo-a-notification__close",
          on: { click: _vm.handleClose },
        },
        [
          _c("icon", {
            staticClass: "trbo-a-notification__close__icon",
            attrs: { name: "close" },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }